module.exports = __webpack_public_path__ + "static/media/ChangEFactoryINTA0002_design_clean_v001.9198fa24.png";